module.exports = {"450105001":"福建园街道","450105002":"江南街道","450105003":"沙井街道","450105004":"那洪街道","450105005":"金凯街道","450105102":"吴圩镇","450105103":"苏圩镇","450105104":"延安镇","450105105":"江西镇","450105450":"经济技术开发区","450105451":"明阳工业园区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450105.json
// module id = 2071
// module chunks = 0